// src/pages/Privacy.tsx
import React from "react";

export default function Privacy() {
  React.useEffect(() => {
    window.location.replace("https://www.nimos.cloud/privacy");
  }, []);

  return null;
}
